import React from 'react';
import { featuresData } from '../data/mock';
import { Check, ArrowLeft, ArrowRight } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';
import { ContentScene, DisciplineScene, IaScene, nativeMockStyles } from './OpenBroNativeMock';

const SCENES = [DisciplineScene, ContentScene, IaScene];

const FeaturesSection = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();

  return (
    <section className="relative mt-20 px-[30px] lg:px-0">
      <div className="mx-auto max-w-[1140px] space-y-8">
        {featuresData.map((feature, index) => {
          const txt = t.features[index] || {};
          return (
          <article key={index} className={`w-full rounded-[40px] overflow-hidden flex flex-col-reverse ${feature.imageRight ? 'lg:flex-row' : 'lg:flex-row-reverse'}`} style={{ background: '#070b12', border: '1px solid rgba(255,255,255,0.08)' }}>
            <div className="flex-1 pb-[40px] px-[40px] pt-6 lg:py-16 flex flex-col justify-center">
              <h4 className={`max-w-md text-[28px] lg:text-[36px] font-bold leading-[1.2] ${feature.dark ? 'text-white' : 'text-[#1B2A4A]'} ${feature.imageRight ? 'text-left' : 'text-left lg:ml-auto lg:text-left'}`} style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{txt.title}</h4>
              <div className={`mt-4 space-y-3 max-w-md ${feature.imageRight ? '' : 'lg:ml-auto'}`}>
                {(txt.points || []).map((point, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <Check size={18} className={`mt-0.5 flex-shrink-0 ${feature.dark ? 'text-white' : 'text-[#1B2A4A]'}`} />
                    <p className={`text-[15px] leading-[1.6] ${feature.dark ? 'text-[rgba(255,255,255,0.85)]' : 'text-[#1B2A4A]'}`} style={{ fontFamily: '"Inter", sans-serif' }}>{point}</p>
                  </div>
                ))}
              </div>
              <div className={`mt-6 ${feature.imageRight ? '' : 'lg:ml-auto lg:max-w-md'}`}>
                <div onClick={() => startCheckout('features_cta')} className="cursor-pointer">
                  {feature.dark ? (
                    <button className="lg:w-min lg:min-w-[266px] text-[#1B2A4A] text-xl border-2 p-[1px] group bg-[#F2F5FB] border-[#1B2A4A] hover:text-white duration-300 transition-all font-bold"><div className="bg-white py-3.5 px-9 group-hover:bg-[#1B2A4A] duration-300 transition-all m-[1px]">{t.hero.cta}</div></button>
                  ) : (
                    <button className="lg:w-min lg:min-w-[266px] text-white text-xl border-2 p-[1px] group bg-white border-[#1B2A4A] hover:text-[#1B2A4A] duration-300 transition-all font-bold"><div className="bg-[#1B2A4A] py-3.5 px-9 group-hover:bg-white duration-300 transition-all m-[1px]">{t.hero.cta}</div></button>
                  )}
                </div>
              </div>
            </div>
            <div className="flex-1 flex items-center justify-center min-h-[440px] py-8">
              {React.createElement(SCENES[index] || DisciplineScene)}
            </div>
          </article>
          );
        })}
      </div>

      <div className="flex items-center justify-center gap-2 mt-10">
        <button className={`cursor-pointer border-[1px] rounded-full p-2 duration-300 transition-all ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'black', borderColor: isDark ? '#E6EBF2' : 'black' }}><ArrowLeft size={16} /></button>
        <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? '#E6EBF2' : '#1B2A4A' }} />
        <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? 'rgba(0,212,255,0.15)' : '#E0E0E0' }} />
        <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? 'rgba(0,212,255,0.15)' : '#E0E0E0' }} />
        <button className={`cursor-pointer border-[1px] rounded-full p-2 duration-300 transition-all ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'black', borderColor: isDark ? '#E6EBF2' : 'black' }}><ArrowRight size={16} /></button>
      </div>
      <style>{nativeMockStyles}</style>
    </section>
  );
};

export default FeaturesSection;
